import { Component } from '@angular/core';

@Component({
    selector:'app-main',
    templateUrl: './app.main.html'
})
export class AppMain {}


// WEBPACK FOOTER //
// ./src/app/app.main.ts